import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent {

  term = '';

  @Output() submitted = new EventEmitter();

  onFormSubmit(value:any){
    value.preventDefault();
    this.submitted.emit(this.term);

  }


}
